export default __webpack_public_path__ + "static/default-profile-dc2aace4a3154a58299750528fe9e558.png";